/**
 * Waits for the GA loading and returns it once ready.
 * @returns {UniversalAnalytics.ga} Google Analycs Object
 */
const getGAObject = (): Promise<UniversalAnalytics.ga> =>
  new Promise((resolve) => {
    let interval: NodeJS.Timeout;

    if (window.ga && typeof window.ga === 'function') {
      resolve(window.ga);
    } else {
      const command = () => {
        if (window.ga) {
          clearInterval(interval);
          resolve(window.ga);
        }
      };

      interval = setInterval(command, 200);
    }
  });

/**
 * Returns Promise that resolves with `cid` from GA.
 * @returns {Promise<string>} client ID from GA
 */
const getClientId = (): Promise<string> => getGAObject().then((ga) => ga.getAll()[0]?.get('clientId') ?? '');

/**
 * Returns Promise that resolves with `cid` if it's available, or `undefined` if error occurs, or it takes too long.
 */
const getClientIdWithTimeout = (): Promise<string> =>
  Promise.race([
    getClientId(),
    new Promise<void>((resolve) =>
      setTimeout(() => {
        console.log('Getting CID has timed out');
        resolve(undefined);
      }, 1000),
    ),
  ]).then(
    (value) => value ?? '',
    (err: unknown) => {
      console.error(err);

      return '';
    },
  );

export { getClientId, getClientIdWithTimeout };
